import { render, staticRenderFns } from "./ship-plan-detail.vue?vue&type=template&id=b29b494c&scoped=true&"
import script from "./ship-plan-detail.vue?vue&type=script&lang=js&"
export * from "./ship-plan-detail.vue?vue&type=script&lang=js&"
import style0 from "./ship-plan-detail.vue?vue&type=style&index=0&id=b29b494c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b29b494c",
  null
  
)

export default component.exports